// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"VideoModal_modal_wrapper__8Yj5e","modal":"VideoModal_modal__oOXoM","video":"VideoModal_video__Suuk5"};